<template>
  <div class="contentBox" :style="{minHeight: winHeight}">
    <div class="topBar">
      <div class="topBarBox">
        <p class="title">{{ $t("login.title") }}</p>
        <div class="language">
          <ChangeLanguage></ChangeLanguage>
        </div>
        <div class="system-message" v-if="path !== '/'">
          <p class="notice" @click="openMessageCenter"><img src="../../assets/images/icon-xiaoxi.png" /><em class="bedge">{{ noticeNum | countNum }}</em></p>
          <audio id="audio" controls="controls" style="height: 0" ref="audio" src="../../assets/audio/ding.mp3" />
        </div>
        <div v-if="path !== '/'" class="companyName">
          <el-popover placement="bottom-end" trigger="hover">
            <div class="login-menu">
<!--              <p class="text-center" @click="tipPopShow" v-if="userType === '2'">{{ $t("login.resetPwd") }}</p>-->
              <p class="text-center" @click="tipPopShow">{{ $t("login.resetPwd") }}</p>
              <p class="text-center" @click="logout">{{ $t("login.logout") }}</p>
            </div>
            <el-button slot="reference" class="login-out-btn">
              {{$t("login.hello")}} {{loanName}} <i class="iconfont icon-sanjiaojiantou_xiangxia"></i>
            </el-button>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="contentBg">
      <Box>
        <Head></Head>
        <slot></slot>
      </Box>
    </div>

    <!--修改密码弹窗开始-->
    <el-dialog :visible.sync="tipPopVisible" custom-class="tipPop tipDialog" :show-close="true" :title="$t('login.resetPwd')">
      <div class="d-body">
        <template v-if="active === 1">
          <div class="txt">{{ $t("login.sendCodeToEmail") }} {{ email }} {{ $t("login.sendCodeValidate") }}</div>
          <el-form class="d-main">
            <el-input v-model="verificationCode" :placeholder="$t('login.inputCode')" size="small" class="w230" maxlength="6" :clearable="true"></el-input>
            <el-button type="primary" size="small" class="w100" @click="sendEmialGetCode(loanName)" :loading="loading">{{ $t("login.sendCode") }}</el-button>
          </el-form>
          <div class="tip"><span v-show="!verificationCode && verificationId !== ''">{{ $t("login.inputReceiveNo") }}【{{ verificationId }}】{{ $t("login.inputReceiveCode") }}</span></div>
        </template>
        <template v-if="active === 2">
          <div class="txt">{{ $t("login.inputNewPwd") }}</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="d-main">
            <el-form-item prop="password">
              <el-input type="password" v-model="ruleForm.password" :placeholder="$t('login.inputNewPassword')"
                        autocomplete="off" size="small" :show-password="true"></el-input>
            </el-form-item>
            <el-form-item prop="checkPass">
              <el-input type="password" v-model="ruleForm.checkPass" :placeholder="$t('login.inputNewPasswordAgin')" autocomplete="off"
                        size="small" :show-password="true"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </div>
      <div class="d-foot">
        <el-button type="primary" v-if="active === 1" :disabled="!verificationCode" @click="checkVerificationCode(verificationCode, loanName)">{{ $t("login.btnNext") }}</el-button>
        <el-button type="primary" v-if="active === 2" @click="submitForm('ruleForm')" :disabled="passwordEqcheckPass">{{ $t("login.btnSubimt") }}</el-button>
      </div>
    </el-dialog>
    <!--修改密码弹窗结束-->

    <el-dialog :visible.sync="tipPopVisible1" :close-on-click-modal="false" custom-class="tipPop tipDialog" :show-close="false">
      <i class="tipsIco" style=""></i>
      <div class="d-body text-center">
        <div class="d-main d-info">
          <h3>{{ $t("login.success") }}</h3>
          <div class="txt">{{ $t("login.text1") }} <span style="color: #EE6723">({{ total }}s)</span>{{ $t("login.text2") }}</div>
        </div>
      </div>
      <div class="d-foot text-center" style="box-shadow: none">
        <el-button type="primary" @click="logout">{{ $t("login.btnOK") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import Box from "../Box";
import Head from "../Head";
import ChangeLanguage from "../ChangeLanguage";
export default {
  name: "ContentBox",
  components: {
    Box,
    Head,
    ChangeLanguage
  },
  data() {
    let validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t("login.inputPwd")));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    let validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t("login.inputNewPasswordAgin")));
      } else if (value !== this.ruleForm.password) {
        callback(new Error(this.$t("login.inputPwdNotEq")));
      } else {
        callback();
      }
    };
    return {
      winHeight: document.documentElement.clientHeight - 70 + "px",
      path: null,

      systemHead: {},
      email: '',            // 用户邮箱
      verificationCode: '', // 邮箱验证码
      verificationId: '',   // 验证码ID
      tipPopVisible: false, // 是否显示修改密码弹窗
      tipPopVisible1: false,

      active: 1,
      loading: false,
      total: 3,

      ruleForm: {
        password: '',
        checkPass: '',
      },
      rules: {
        password: [
          {validator: validatePassword, trigger: 'blur'}
        ],
        checkPass: [
          {validator: validateCheckPass, trigger: 'blur'}
        ]
      },
      noticeNum:0,
      maxId:'', // 上一次获取未读数的id
    };
  },
  computed: {
    ...mapState(['userProfile']),
    loanName() {
      return this.userProfile.loanName; // 登录用户名
    },
    userType() {
      return this.userProfile.type;
    },
    passwordEqcheckPass() {
      let {password, checkPass} = this.ruleForm;
      return password === '' || checkPass === '' || password !== checkPass
    }
  },
  watch: {
    $route() {
      this.path = this.$route.path;
      if (this.$route.path !== "/") {
        this.getSystemHead();
        this.getUnReadCount();
      }
    }
  },
  methods: {

    /**
     * 获取公司信息
     */
    getSystemHead() {
      this.axios.post("/homePage/getSystemHead").then(res => {
        if (res.status) {
          this.systemHead = res.data;
        }
      });
    },

    /**
     * 显示修改密码弹窗
     */
    tipPopShow() {
      this.active = 1;
      this.verificationCode = '';
      this.verificationId = '';
      this.ruleForm.password = '';
      this.ruleForm.checkPass = '';
      this.tipPopVisible = true;
      this.queryEmail(this.loanName);
    },

    /**
     * 获取用户邮箱
     * @param loanName
     */
    queryEmail(loanName) {
      this.axios.post("/api/zma/userCenter/queryEmail", {loanName}).then(res => {
        if (res.status) {
          this.email = res.data.email;
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`));
        }
      });
    },

    /**
     * 校验验证码是否正确接口
     * @param v_f 邮箱验证码
     */
    checkVerificationCode(v_f) {
      this.axios.post("/api/zma/userCenter/checkVerificationCode", {v_f}).then(res => {
        if (res.status) {
          this.active = 2;
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`));
        }
      });
    },

    /**
     * 发送邮件验证码
     * @param loanName 登录用户名
     */
    sendEmialGetCode(loanName) {
      this.loading = true;
      this.axios.post("/api/zma/userCenter/sendEmialGetCode", {loanName}).then(res => {
        this.loading = false;
        if (res.status) {
          this.verificationId = res.data;
          this.active = 1;
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`));
        }
      });
    },

    /**
     * 修改密码接口
     * @param p_w      输入新密码
     * @param passwordAgain 再次确认新密码
     * @param loanName      登录用户名
     */
    updatePassWord(p_w, p_wa, loanName) {
      this.axios.post("/api/zma/userCenter/updatePassWord", {p_w, p_wa, loanName}).then(res => {
        if (res.status) {
          this.tipPopVisible = false;
          this.tipPopVisible1 = true;
          this.countDown();
        } else {
          this.$message.error(this.$t(`error.${res.errorCode}`));
        }
      });
    },

    /**
     * 提交表单
     * @param formName 表单名称
     */
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updatePassWord(this.ruleForm.password, this.ruleForm.checkPass, this.loanName);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    /**
     * 退出登录
     */
    logout() {
      this.axios.post("/logout").then(res => {
        if (res.status) {
          this.tipPopVisible = false;
          this.tipPopVisible1 = false;
          this.$store.commit('EMPTY_USER_INFO');
          this.$router.push("/");
        }
      });
    },

    /**
     * 倒计时
     */
    countDown() {
      let clock = window.setInterval(() => {
        this.total--;
        if (this.total < 1) {
          this.total = 3;
          window.clearInterval(clock);
          this.logout();
        }
      },1000);
    },

    messageCountDown(){
      var second = 120
      window.setInterval(() => {
        second --;
        if (second == 0){
          second = 120
          this.getUnReadCount()
        }

      },1000);
    },

    //打开消息列表
    openMessageCenter(){
      // let href = this.$router.resolve({
      //   path: 'messageCenter',
      //   query: {}
      // })
      // window.open(href.href, '_blank')
      this.$router.push('/messageCenter');
    },
    audioAutoPlay(){
      let audio = document.getElementById('audio');
      audio.play();
    }, // 触发播放
    //获取未读消息数字
    getUnReadCount(){
      let _this = this;
      if (!this.loanName){
        return false
      }
      _this.axios.post("/api/zma/msg/getUnReadCount", {maxId: _this.maxId}).then(res => {
        if (res.status) {
          let data = res.data;
          _this.noticeNum = data.totalCount;
          _this.maxId = data.maxId;
          if(data.newCount){
            _this.audioAutoPlay();
            // try {
            //   _this.audioAutoPlay();
            // } catch (e) {
            //   document.addEventListener('touchstart', function () {
            //     _this.audioAutoPlay();
            //   },{once: true});
            // }
          }
        } else {
          _this.noticeNum = 0
          //获取消息数字的接口不提示错误
          // this.$message.error(this.$t(`error.${res.errorCode}`));
        }
      });
    },
  },

  mounted() {
    window.onresize = () => {
      this.winHeight = document.documentElement.clientHeight - 70 + "px";
    };
    this.messageCountDown()

  },
};
</script>
<style lang="scss">
  .contentBox {
    min-width: 1200px;
    background: linear-gradient(to right, #040c2b, #033b7c) 0 0/100% 198px;
    background-repeat: no-repeat;
    background-size: 100% 228px;
    .topBar {
      height: 30px;
      background: #394b7e;
      .topBarBox {
        width: 1200px;
        height: 30px;
        line-height: 30px;
        margin: 0 auto;
        .title {
          float: left;
          color: #fff;
          font-size: 12px;
        }
        .companyName {
          float: right;
          font-size: 14px;
          min-width: 200px;
          color: #c7cce6;
          margin: 0 20px;
          position: relative;
          text-align: right;
          cursor: pointer;
          .login-out-btn {
            padding: 0;
            border: none;
            font-size: 14px;
            color: #C7CCE6;
            background-color: transparent;
          }
          .iconfont {
            display: inline-block;
            transform: scale(.5);
          }
        }

        .language {
          width: 160px;
          float: right;
          font-size: 12px;
          color: #b3b7d1;
          text-align: center;
          position: relative;
        }
        .system-message{
          width: 62px;
          height: 100%;
          float: right;
          text-align: center;
          position: relative;
          .notice{
            //padding: 0 12px 0 31px;
            height: 100%;
            display: flex;
            &:hover{
              cursor: pointer;
            }
          }
          .bedge{
            background: #E44245;
            margin-left: 5px;
            font-size: 12px;
            color: #FFFFFF;
            min-width: 18px;
            height: 18px;
            margin-top: 6px;
            text-align: center;
            line-height: 18px;
            padding: 0 4px;
            border-radius:10px;
            display: inline-block;
            box-sizing: border-box;
            font-style: initial
          }
        }
      }
    }
    .tipDialog {
      padding-bottom: 0;
      .el-dialog__header {
        padding: 23px 35px;
      }
      .el-dialog__body {
        padding: 0 25px;
        box-sizing: border-box;
        .d-info {
          padding-top: 64px;
          h3 {
            font-size: 18px;
            color: #333333;
          }
        }
        .d-body{
          display: flex;
          flex-direction: column;
          padding: 0 30px;
          .txt{
            padding: 20px 0;
            text-align: center;
            font-size: 14px;
            color: #81899E;
          }
          .tip {
            padding: 10px 0 15px 0;
            font-size: 12px;
            color: #F47272;
          }
          .el-input__inner {
            padding: 0 25px 0 10px;
          }
          .w230.el-input {
            width: 230px;
            .el-input__inner {
              height: 36px;
              line-height: 36px;
              border-right: transparent;
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;
            }
          }
          .el-button.w100 {
            width: 100px;
            padding: 11px 20px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
        }
        .d-foot{
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 16px 0;
          background: #FFFFFF;
          box-shadow: inset 0 1px 0 0 #EAEAEA;
          .el-button {
            min-width: 150px;
            border-radius: 2px;
            padding: 11px 20px;
          }
          .el-button--default{
            border: 1px solid #7996F5;
            color: #7996F5;
          }
        }
      }
    }
  }
  .contentBg {
    min-height: 198px;
    background: url("../../assets/headBg.png") repeat-x 0 0/197px 198px;
  }
  .login-menu {
    cursor: pointer;
    p {
      height: 36px;
      line-height: 36px;
    }
  }
  .el-popover {
    padding: 0 12px !important;
  }
</style>
